import { adminHttpClient } from '../commons/adminHttpClient'

export type EditInsurancePremiumRequest = {
  amount: number
  startDate: string
  attachments: AttachmentProps[]
  familyMemberCoveredByThisPolicyIds: string[]
  familyMemberId: string
}

type AttachmentProps = {
  id?: string
  filename: string
  title: string
  reuseInOtherExpenses: boolean
}

export type EditInsurancePremiumProps = {
  premiumId: string
  values: EditInsurancePremiumRequest
}

const editInsurancePremium = ({ premiumId, values }: EditInsurancePremiumProps): Promise<string> => {
  return adminHttpClient.put(`/UpdatePremium/${premiumId}`, values)
}

export default editInsurancePremium
